import { Link } from "react-router-dom";
import { t } from "../i18n";

/** Logotip: üç sıra taş (kademeli duvar) + ad. İkon dekor değil, ürünün kendisi. */
export function WallGlyph({ size = 22, className = "" }: { size?: number; className?: string }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden className={className}>
      <g fill="currentColor">
        <rect x="9" y="3" width="10" height="5" rx="0.5" /><rect x="6" y="9.5" width="7" height="5" rx="0.5" /><rect x="14" y="9.5" width="7" height="5" rx="0.5" />
        <rect x="3" y="16" width="8" height="5" rx="0.5" /><rect x="12" y="16" width="10" height="5" rx="0.5" />
      </g>
    </svg>
  );
}
export function Wordmark({ to = "/", className = "" }: { to?: string; className?: string }): JSX.Element {
  return (
    <Link to={to} className={`inline-flex items-center gap-2 text-ink font-semibold tracking-tight ${className}`} aria-label={t("TaşDuvar ana sayfa")}>
      <WallGlyph className="text-ink" /><span>{t("TaşDuvar")}</span>
    </Link>
  );
}
